// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__FSFZg","title":"Info_title__10MIw","selects":"Info_selects__2rqPO","requiredAsterisk":"Info_requiredAsterisk__1zkWn"};